import POSSelectorButton from '../../../Buttons/POSSelectorButton';

interface Props {
  priceMax: number;

  disabled?: boolean;

  onClick: () => void;
}

const POSPriceFilterCard = ({ priceMax, disabled, onClick }: Props) => {
  return (
    <POSSelectorButton
      label="Precio máximo"
      value={`$${priceMax.toFixed(2)}`}
      selected={priceMax > 0}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default POSPriceFilterCard;
